// extracted by mini-css-extract-plugin
export default {"container":"SmartLayer_container__dNM3z","children":"SmartLayer_children__S6eeh"};